export default "__VITE_ASSET__8c616c3b__"